import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router' //import router for child
import { FormsModule } from '@angular/forms'; // import angular form
import { HttpModule } from '@angular/http';　// Import HttpClientModule from @angular/common/http
import { ModalModule } from 'ngx-bootstrap/modal'; //import for module boostrap
//import elements components  
import { BsDropdownModule } from 'ngx-bootstrap/dropdown'

import { SidebarComponent } from '../../component/elements/navigation/sidebar/sidebar.component'; //import navbar of component
import { PaginationComponent } from '../../component/elements/pagination/pagination.component';
import { NavbarComponent } from '../../component/elements/navigation/navbar/navbar.component';
import { PageNavBarHeaderComponent } from '../../component/elements/pageNavBarHeader/pageNavBarHeader.component';
import { LoadingComponent } from './loading_component/loading.component';
import { ErrorComponent } from './error_component/error.component';
import { NoDataComponent } from './no_data_component/noData.component';
import { StudentModalComponent } from '../customer/commentary-modal/student-modal.component';
import { StudentModalPerTrainingComponent } from '../customer/commentary-modal/student-modal-per-training.component';
import { AnswerComponent as AnswerPageComponent } from './answer_component/answer.component';
import { FeedbackComponent } from './answer_component/feedback/feedback.component';
import { AccountInfoComponent } from './account_component/account_info.component';
import { SnackbarComponent } from './snackbar_component/snackbar.component';

import { ConfirmationModalComponent } from './confirmation_modal/confirmation_modal.component';


import { PreviewService } from 'aplication/preview/preview.service';
import { AnswerService } from 'student/answer/answer.service';
import { DashboardService } from 'aplication/dashboard/dashboard.service';
import { courseFormatService } from 'aplication/courseformat/courseformat.service';


@NgModule({
  declarations: [ 
    SidebarComponent,
    NavbarComponent,
    PaginationComponent,
    LoadingComponent,
    ErrorComponent,
    StudentModalComponent,
    StudentModalPerTrainingComponent,
    AnswerPageComponent,
    ConfirmationModalComponent,
    FeedbackComponent,
    NoDataComponent,
    AccountInfoComponent,
    SnackbarComponent,
    PageNavBarHeaderComponent,
  ],
  imports: [ 
    FormsModule,
    HttpModule,
    CommonModule,
    ModalModule.forRoot(),
    RouterModule,
    BsDropdownModule,
  ],
  exports: [ 
    SidebarComponent,
    NavbarComponent,
    PaginationComponent,
    LoadingComponent,
    ErrorComponent,
    AnswerPageComponent,
    FeedbackComponent,
    NoDataComponent,
    AccountInfoComponent,
    SnackbarComponent,
    PageNavBarHeaderComponent,
  ],
  bootstrap: [],
  entryComponents: [
    StudentModalComponent,
    StudentModalPerTrainingComponent,
    ConfirmationModalComponent,
  ],
  providers: [
    PreviewService,
    AnswerService,
    DashboardService,
    courseFormatService,
  ]
})
export class SharedModule {}


// WEBPACK FOOTER //
// ./src/app/component/shared/shared.module.ts